/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2018-12-28 12:09:05
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-13 14:18:34
 */
const getters = {
    device: state => state.app.device,
    theme: state => state.app.theme,
    color: state => state.app.color,
    showTabMenu: state => state.app.showTabMenu,
    currentStep: state => state.app.currentStep,
    token: state => state.user.token,
    org: state => state.user.org,
    orgList: state => state.user.orgList,
    avatar: state => state.user.avatar,
    nickname: state => state.user.name,
    welcome: state => state.user.welcome,
    perm_list: state => state.user.perm_list,
    userInfo: state => state.user.info,
    addRouters: state => state.permission.addRouters,


    // theme:state =>state.accounts.theme,
    // 客户资料功能的选中客户信息
    currentCustInfo: state => state.accounts.currentCustInfo,
    // 电销业务功能的选中客户信息
    ESPCustInfo: state => state.accounts.ESPCustInfo,
    // 电销业务功能的是否点击下一条的状态管理
    ESPCIisNext: state => state.accounts.ESPCIisNext,
    // 电销业务功能加载状态管理
    spBusiness: state => state.accounts.spBusiness,
    // 电销下的跟踪记录
    spTrackRecord: state => state.accounts.spTrackRecord,
    // 电销下的算价系统
    spCalculatePrice: state => state.accounts.spCalculatePrice,
    id: state => state.accounts.id,
    owner: state => state.accounts.owner,
    mobile: state => state.accounts.mobile,
    condition: state => state.accounts.condition,
    trackRecordCondition: state => state.accounts.trackRecordCondition,

    //名单id
    listId: state => state.callList.listId,


    // 组织机构选择的节点ID
    node_id: state => state.organization.node_id,
    
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js